import { Component, Input } from '@angular/core';

@Component({
  selector: 'liberro-thematic-strategy-preview-stack',
  standalone: false,
  templateUrl: './liberro-thematic-strategy-preview-stack.component.html',
  styleUrl: './liberro-thematic-strategy-preview-stack.component.less'
})
export class LiberroThematicStrategyPreviewStackComponent {
  @Input() public variant: 'grid' | 'empty' = 'grid';
}
